// extracted by mini-css-extract-plugin
var _1 = "CopyLink-module_copyButton__VrW0l";
export { _1 as "copyButton" }
export default { "copyButton": _1 }
